import { Route } from "react-router";
import Activities from "../crm/activities";
import ContactDetails from "../crm/contacts";
import DealsDashboard from "../mainMenu/dealsDashboard";
import BlankPage from "../pages/blankPage";
import { all_routes } from "./all_routes";

import EmailVerification from "../auth/emailVerification";
import ForgotPassword from "../auth/forgotPassword";
import Login from "../auth/login";
import Register from "../auth/register";
import ResetPassword from "../auth/resetPassword";
import Success from "../auth/success";
import TwoStepVerification from "../auth/twoStepVerification";
import LockScreen from "../authentication/lockscreen";
import LeadsDetails from "../crm/leads";
import ComingSoon from "../pages/comingSoon";
import Error404 from "../pages/error/error-404";
import Error500 from "../pages/error/error-500";
import UnderMaintenance from "../pages/underMaintenance";
import Manageusers from "../userManagement/manageUsers/manageusers";

// import BanIpAddress from "../settings/otherSettings/banIpaddress";
// import LostReason from "../crmSetting/lostreason";
import Permissions from "../userManagement/Permissions/permissions";
import RolesPermissions from "../userManagement/Roles/Roles";
// import Organization from "../userManagement/Organization";
import { useSelector } from "react-redux";
import Settings from "../Setting/Settings";
import Task from "../crm/task";
import Accounts from "../userManagement/Accounts/Accounts";
import AddAccounts from "../userManagement/Accounts/AddAccounts";
import BusinessUnit from "../userManagement/BusinessUnit/BusinessUnit";
import AddContacts from "../userManagement/Contacts/AddContacts";
import Contacts from "../userManagement/Contacts/Contacts";
import LeadInquiry from "../userManagement/LeadInquiry/LeadInquiry";
import UpdateLeadInquiry from "../userManagement/LeadInquiry/UpdateLeadInquiry";
import Leads from "../userManagement/Leads/Leads";
import AddLead from "../userManagement/LeadsProspect/AddLead";
import LeadProspect from "../userManagement/LeadsProspect/LeadsProspect";
import LeadsUserDetails from "../userManagement/LeadsTabs/LeadsUserDetails";

import ProjectsTabsRoutes from "../userManagement/ProjectTabs/ProjectsTabsRoutes";
import Projects from "../userManagement/Projects/Projects";
import TasksMain from "../userManagement/TasksMain/TasksMain";
import Teams from "../userManagement/Teams/Teams";
import Organization from "../userManagement/organization";
import Report1 from "../userManagement/reportAndAnalytics/PdmYoyReport";
import DocumentPermissionMainTab from "../userManagement/Document Permission Main/DocumentPermissionMaintab";
import MbuReporting from "../userManagement/MBU Reporting/MbuReporting";
import MbuListing from "../userManagement/MBU Reporting/MbuListing";
import EnterPriseReport from "../userManagement/MBU Reporting/EnterPriseReport";
// import ChartJs from "../uiInterface/charts/chartjs";

const route = all_routes;

export const usePublicRoutes = () => {
  const allPermissions = useSelector((per: any) => per?.auth?.userDetail);
  const role = allPermissions?.roleName

  return [
    {
      path: route.rolesPermissions,
      element: <RolesPermissions />,
      route: Route,
    },
    {
      path: route.permissions,
      element: <Permissions />,
      route: Route,
    },
    {
      path: route.teams,
      element: <Teams />,
      route: Route,
    },
    {
      path: route.manageusers,
      element: <Manageusers />,
      route: Route,

    },
    {
      path: route.leadsProspect,
      element: <LeadProspect />,
      route: Route,
    },
    {
      path: route.dealsDashboard,
      element: <DealsDashboard />,
      route: Route,
    },
    // {
    //   path: route.projectUserDetails,
    //   element: <ProjectUserDetails />,
    //   route: Route,
    // },
    {
      path: route.editProject,
      element: <ProjectsTabsRoutes />,
      route: Route,
    },
    {
      path: route.viewProject,
      element: <ProjectsTabsRoutes />,
      route: Route,
    },
    {
      path: route.contacts,
      element: <Contacts />,
      route: Route,
    },
    {
      path: route.AddContacts,
      element: <AddContacts />,
      route: Route,
    },
    {
      path: route.viewContacts,
      element: <AddContacts />,
      route: Route,
    },
    {
      path: route.EditContacts,
      element: <AddContacts />,
      route: Route,
    },
    {
      path: route.tasksMain,
      element: <TasksMain />,
      route: Route,
    },
    {
      path: route.leadsUserDetails,
      element: <LeadsUserDetails />,
      route: Route,
    },
    {
      path: route.Addleads,
      element: <AddLead />,
      route: Route,
    },
    {
      path: route.viewLead,
      element: <AddLead />,
      route: Route,
    },
    {
      path: route.editLead,
      element: <AddLead />,
      route: Route,
    },
    {
      path: route.editLead,
      element: <LeadsUserDetails />,
      route: Route,
    },
    {
      path: route.activities,
      element: <Activities />,
      route: Route,
    },
    {
      path: route.contactDetails,
      element: <ContactDetails />,
      route: Route,
    },
    {
      path: route.accounts,
      element: <Accounts />,
      route: Route,
    },
    {
      path: route.AddAccounts,
      element: <AddAccounts />,
      route: Route,
    },
    {
      path: route.EditAccounts,
      element: <AddAccounts />,
      route: Route,
    },
    {
      path: route.ViewAccounts,
      element: <AddAccounts />,
      route: Route,
    },

    {
      path: route.leadsUserDetails,
      element: <LeadsUserDetails />,
      route: Route,
    },
    {
      path: route.organization,
      element: <Organization />,
      route: Route,
    },
    {
      path: route.leadsDetails,
      element: <LeadsDetails />,
      route: Route,
    },

    {
      path: route.leads,
      element: <Leads />,
      route: Route,
    },
    {
      path: route.leadsInquiry,
      element: <LeadInquiry />,
      route: Route,
    },
    {
      path: route.editLeadInquiry,
      element: <UpdateLeadInquiry />,
      route: Route,
    },
    {
      path: route.viewLeadInquiry,
      element: <UpdateLeadInquiry />,
      route: Route,
    },
    // {
    //   path: route.addLeadInquiry,
    //   element: <AddLeadInquiry />,
    //   route: Route,
    // },

    {
      path: route.businessUnit,
      element: <BusinessUnit />,
      route: Route,
    },
    {
      path: route.rolesPermissions,
      element: <RolesPermissions />,
      route: Route,
    },
    {
      path: route.permissions,
      element: <Permissions />,
      route: Route,
    },
    {
      path: route.documentPermissionsTab,
      element: <DocumentPermissionMainTab />,
      route: Route,
    },
    {
      path: route.teams,
      element: <Teams />,
      route: Route,
    },
    {
      path: route.projects,
      element: <Projects />,
      route: Route,
    },
    {
      path: route.tasks,
      element: <Task />,
      route: Route,
    },
    {
      path: route.settings,
      element: <Settings />,
      route: Route,
    },

    {
      path: route.pdmYoyReport,
      element: <Report1 />,
      route: Route,
    },
    {
      path: route.mbuReport,
      element: <MbuReporting />,
      route: Route,
    },
    {
      path: route.mbuListing,
      element: <MbuListing />,
      route: Route,
    },
    {
      path: route.enterPriseReport,
      element: <EnterPriseReport />,
      route: Route,
    },
    // {
    //   path: route.audioCall,
    //   element: <AudioCall />,
    //   route: Route,
    // },
    // {
    //   path: route.callHistory,
    //   element: <CallHistory />,
    //   route: Route,
    // },
    // {
    //   path: route.leadsKanban,
    //   element: <LeadsKanban />,
    //   route: Route,
    // },
    // {
    //   path: route.callHistory,
    //   element: <CallHistory />,
    //   route: Route,
    // },
    // {
    //   path: route.campaign,
    //   element: <Campaign />,
    //   route: Route,
    // },
    // {
    //   path: route.activityMeeting,
    //   element: <ActivityMetting />,
    //   route: Route,
    // },
    // {
    //   path: route.activityCalls,
    //   element: <ActivityCalls />,
    //   route: Route,
    // },
    // {
    //   path: route.activityMail,
    //   element: <ActivityMail />,
    //   route: Route,
    // },
    // {
    //   path: route.activityTask,
    //   element: <ActivityTask />,
    //   route: Route,
    // },
    // {
    //   path: route.campaignComplete,
    //   element: <CampaignComplete />,
    //   route: Route,
    // },
    // {
    //   path: route.campaignArchieve,
    //   element: <CampaignArchieve />,
    //   route: Route,
    // },
    // {
    //   path: route.appearance,
    //   element: <Appearance />,
    //   route: Route,
    // },
    // {
    //   path: route.analytics,
    //   element: <Analytics />,
    //   route: Route,
    // },
    // {
    //   path: route.connectedApps,
    //   element: <ConnectedApps />,
    //   route: Route,
    // },
    // {
    //   path: route.countries,
    //   element: <Country />,
    //   route: Route,
    // },

    // {
    //   path: route.bankAccounts,
    //   element: <BankAccounts />,
    //   route: Route,
    // },
    // {
    //   path: route.blankPage,
    //   element: <BlankPage />,
    //   route: Route,
    // },
    // {
    //   path: route.calendar,
    //   element: <Calendar />,
    //   route: Route,
    // },


    // {
    //   path: route.membershipplan,
    //   element: <Membershipplan />,
    // },
    // {
    //   path: route.membershipAddon,
    //   element: <MembershipAddon />,
    // },
    // {
    //   path: route.membershipTransaction,
    //   element: <MembershipTransaction />,
    // },
    // {
    //   path: route.notes,
    //   element: <Notes />,
    // },
    // {
    //   path: route.contactStage,
    //   element: <ContactStage />,
    //   route: Route,
    // },

    //   {
    //     path: route.countries,
    //     element: <Countries />,
    //     route: Route,
    //   },
    //   {
    //     path: route.currencies,
    //     element: <Currencies />,
    //     route: Route,
    //   },
    //   {
    //     path: route.customFields,
    //     element: <CustomFields />,
    //     route: Route,
    //   },
    //   {
    //     path: route.dataTables,
    //     element: <DataTable />,
    //     route: Route,
    //   },
    //   {
    //     path: route.tablesBasic,
    //     element: <BasicTable />,
    //     route: Route,
    //   },
    //   {
    //     path: route.dealReports,
    //     element: <DealReports />,
    //     route: Route,
    //   },

    //   {
    //     path: route.deals,
    //     element: <Deals />,
    //     route: Route,
    //   },

    //   {
    //     path: route.dealsDetails,
    //     element: <DealsDetails />,
    //     route: Route,
    //   },
    //   {
    //     path: route.dealsKanban,
    //     element: <DealsKanban />,
    //     route: Route,
    //   },
    //   {
    //     path: route.deleteRequest,
    //     element: <DeleteRequest />,
    //     route: Route,
    //   },
    //   {
    //     path: route.cities,
    //     element: <Cities />,
    //     route: Route,
    //   },
    //   {
    //     path: route.companies,
    //     element: <Companies />,
    //     route: Route,
    //   },
    //   { path: route.localization, element: <Localization />, route: Route },

    //   {
    //     path: route.companies,
    //     element: <Companies />,
    //     route: Route,
    //   },
    //   {
    //     path: route.alert,
    //     element: <Alert />,
    //     route: Route,
    //   },
    //   {
    //     path: route.accordion,
    //     element: <Accordion />,
    //     route: Route,
    //   },
    //   {
    //     path: route.avatar,
    //     element: <Avatar />,
    //     route: Route,
    //   },
    //   {
    //     path: route.border,
    //     element: <Borders />,
    //     route: Route,
    //   },
    //   {
    //     path: route.breadcrums,
    //     element: <Breadcrumb />,
    //     route: Route,
    //   },
    //   {
    //     path: route.button,
    //     element: <Buttons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.buttonGroup,
    //     element: <ButtonsGroup />,
    //     route: Route,
    //   },
    //   {
    //     path: route.cards,
    //     element: <Cards />,
    //     route: Route,
    //   },
    //   {
    //     path: route.carousel,
    //     element: <Carousel />,
    //     route: Route,
    //   },
    //   {
    //     path: route.colors,
    //     element: <Colors />,
    //     route: Route,
    //   },
    //   {
    //     path: route.dropdowns,
    //     element: <Dropdowns />,
    //     route: Route,
    //   },
    //   {
    //     path: route.grid,
    //     element: <Grid />,
    //     route: Route,
    //   },
    //   {
    //     path: route.images,
    //     element: <Images />,
    //     route: Route,
    //   },
    //   {
    //     path: route.lightbox,
    //     element: <Lightboxes />,
    //     route: Route,
    //   },
    //   {
    //     path: route.media,
    //     element: <Media />,
    //     route: Route,
    //   },
    //   {
    //     path: route.modals,
    //     element: <Modals />,
    //     route: Route,
    //   },
    //   {
    //     path: route.navTabs,
    //     element: <NavTabs />,
    //     route: Route,
    //   },
    //   {
    //     path: route.offcanvas,
    //     element: <Offcanvas />,
    //     route: Route,
    //   },
    //   {
    //     path: route.pagination,
    //     element: <Pagination />,
    //     route: Route,
    //   },
    //   {
    //     path: route.popover,
    //     element: <Popovers />,
    //     route: Route,
    //   },
    //   {
    //     path: route.rangeSlider,
    //     element: <RangeSlides />,
    //     route: Route,
    //   },
    //   {
    //     path: route.progress,
    //     element: <Progress />,
    //     route: Route,
    //   },
    //   {
    //     path: route.spinner,
    //     element: <Spinner />,
    //     route: Route,
    //   },

    //   {
    //     path: route.typography,
    //     element: <Typography />,
    //     route: Route,
    //   },
    //   {
    //     path: route.video,
    //     element: <Video />,
    //     route: Route,
    //   },
    //   {
    //     path: route.toasts,
    //     element: <Toasts />,
    //     route: Route,
    //   },
    //   {
    //     path: route.customFields,
    //     element: <CustomFields />,
    //     route: Route,
    //   },
    //   {
    //     path: route.invoiceSettings,
    //     element: <InvoiceSettings />,
    //     route: Route,
    //   },
    //   {
    //     path: route.printers,
    //     element: <Printers />,
    //     route: Route,
    //   },
    //   {
    //     path: route.bankAccounts,
    //     element: <BankAccounts />,
    //     route: Route,
    //   },
    //   {
    //     path: route.currencies,
    //     element: <Currencies />,
    //     route: Route,
    //   },
    //   {
    //     path: route.paymentGateways,
    //     element: <PaymentGateways />,
    //     route: Route,
    //   },
    //   {
    //     path: route.taxRates,
    //     element: <TaxRates />,
    //     route: Route,
    //   },
    //   {
    //     path: route.connectedApps,
    //     element: <ConnectedApps />,
    //     route: Route,
    //   },
    //   {
    //     path: route.notification,
    //     element: <Notifications />,
    //     route: Route,
    //   },
    //   {
    //     path: route.profile,
    //     element: <Profile />,
    //     route: Route,
    //   },
    //   {
    //     path: route.security,
    //     element: <Security />,
    //     route: Route,
    //   },
    //   // {
    //   //   path: route.banIpAddrress,
    //   //   element: <BanIpAddress />,
    //   //   route: Route,
    //   // },
    //   {
    //     path: route.storage,
    //     element: <Storage />,
    //     route: Route,
    //   },
    //   {
    //     path: route.emailSettings,
    //     element: <EmailSettings />,
    //     route: Route,
    //   },
    //   {
    //     path: route.gdprCookies,
    //     element: <GdprCookies />,
    //     route: Route,
    //   },
    //   {
    //     path: route.smsGateways,
    //     element: <SmsGateways />,
    //     route: Route,
    //   },
    //   {
    //     path: route.appearance,
    //     element: <Appearance />,
    //     route: Route,
    //   },
    //   {
    //     path: route.companySettings,
    //     element: <CompanySettings />,
    //     route: Route,
    //   },
    //   {
    //     path: route.language,
    //     element: <Language />,
    //     route: Route,
    //   },
    //   // {
    //   //   path: route.localization,
    //   //   element: <Localization />,
    //   //   route: Route,
    //   // },
    //   {
    //     path: route.preference,
    //     element: <Preference />,
    //     route: Route,
    //   },
    //   {
    //     path: route.prefixes,
    //     element: <Prefixes />,
    //     route: Route,
    //   },
    //   {
    //     path: route.leadsDashboard,
    //     element: <LeadsDashboard />,
    //     route: Route,
    //   },
    //   {
    //     path: route.projectDashboard,
    //     element: <ProjectDashboard />,
    //     route: Route,
    //   },
    //   {
    //     path: route.manageORGAdmin,
    //     element: <ManageORGAdmin />,
    //     route: Route,
    //   },
    //   {
    //     path: route.todo,
    //     element: <Todo />,
    //     route: Route,
    //   },
    //   {
    //     path: route.email,
    //     element: <Email />,
    //     route: Route,
    //   },
    //   {
    //     path: route.videoCall,
    //     element: <VideoCall />,
    //     route: Route,
    //   },
    //   {
    //     path: route.chat,
    //     element: <Chat />,
    //     route: Route,
    //   },
    //   {
    //     path: route.pages,
    //     element: <Pages />,
    //     route: Route,

    //   },
    //   {
    //     path: route.contactList,
    //     element: <ContactList />,
    //     route: Route,
    //   },
    //   {
    //     path: route.companyReports,
    //     element: <CompanyReport />,
    //     route: Route,
    //   },
    //   {
    //     path: route.contactReports,
    //     element: <ContactReport />,
    //     route: Route,
    //   },
    //   {
    //     path: route.dealReports,
    //     element: <DealReports />,
    //     route: Route,
    //   },
    //   {
    //     path: route.leadReports,
    //     element: <LeadReport />,
    //     route: Route,
    //   },
    //   {
    //     path: route.projectReports,
    //     element: <ProjectReport />,
    //     route: Route,
    //   },
    //   {
    //     path: route.taskReports,
    //     element: <TaskReport />,
    //     route: Route,
    //   },
    //   {
    //     path: route.calls,
    //     element: <Calls />,
    //     route: Route,
    //   },
    //   {
    //     path: route.contactStage,
    //     element: <ContactStage />,
    //     route: Route,
    //   },
    //   {
    //     path: route.industry,
    //     element: <Industry />,
    //     route: Route,
    //   },
    //   {
    //     path: route.sources,
    //     element: <Sources />,
    //     route: Route,
    //   },
    //   {
    //     path: route.deleteRequest,
    //     element: <DeleteRequest />,
    //     route: Route,
    //   },
    //   
    //   {
    //     path: route.contactMessages,
    //     element: <ContactMessages />,
    //     route: Route,
    //   },
    //   {
    //     path: route.tickets,
    //     element: <Tickets />,
    //     route: Route,
    //   },
    //   {
    //     path: route.fileManager,
    //     element: <FileManager />,
    //     route: Route,
    //   },
    //   {
    //     path: route.faq,
    //     element: <Faq />,
    //     route: Route,
    //   },
    //   {
    //     path: route.lostReason,
    //     element: <LostReason />,
    //     route: Route,
    //   },
    //   {
    //     path: route.contactGrid,
    //     element: <ContactGrid />,
    //     route: Route,
    //   },
    //   {
    //     path: route.companiesGrid,
    //     element: <CompaniesGrid />,
    //     route: Route,
    //   },
    //   {
    //     path: route.pipeline,
    //     element: <Pipeline />,
    //     route: Route,
    //   },
    //  
    //   {
    //     path: route.companyDetails,
    //     element: <CompaniesDetails />,
    //     route: Route,
    //   },
    //   {
    //     path: route.states,
    //     element: <States />,
    //     route: Route,
    //   },
    //   {
    //     path: route.testimonials,
    //     element: <Testimonials />,
    //     route: Route,
    //   },
    //   {
    //     path: route.clipboard,
    //     element: <ClipBoard />,
    //     route: Route,
    //   },
    //   {
    //     path: route.counter,
    //     element: <Counter />,
    //     route: Route,
    //   },
    //   {
    //     path: route.dragandDrop,
    //     element: <DragAndDrop />,
    //     route: Route,
    //   },
    //   {
    //     path: route.rating,
    //     element: <Rating />,
    //     route: Route,
    //   },
    //   {
    //     path: route.ribbon,
    //     element: <Ribbon />,
    //     route: Route,
    //   },
    //   {
    //     path: route.stickyNotes,
    //     element: <Stickynote />,
    //     route: Route,
    //   },
    //   {
    //     path: route.textEditor,
    //     element: <TextEditor />,
    //     route: Route,
    //   },
    //   {
    //     path: route.timeLine,
    //     element: <Timeline />,
    //     route: Route,
    //   },
    //   {
    //     path: route.scrollBar,
    //     element: <Scrollbar />,
    //     route: Route,
    //   },
    //   {
    //     path: route.scrollBar,
    //     element: <Scrollbar />,
    //     route: Route,
    //   },
    //   {
    //     path: route.apexChat,
    //     element: <Apexchart />,
    //     route: Route,
    //   },
    //   {
    //     path: route.featherIcons,
    //     element: <FeatherIcons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.falgIcons,
    //     element: <FeatherIcons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.fantawesome,
    //     element: <FontawesomeIcons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.fantawesome,
    //     element: <FontawesomeIcons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.materialIcon,
    //     element: <MaterialIcons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.pe7icon,
    //     element: <PE7Icons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.simpleLineIcon,
    //     element: <SimplelineIcons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.themifyIcon,
    //     element: <ThemifyIcons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.typicon,
    //     element: <TypiconIcons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.basicInput,
    //     element: <BasicInputs />,
    //     route: Route,
    //   },
    //   {
    //     path: route.weatherIcon,
    //     element: <WeatherIcons />,
    //     route: Route,
    //   },
    //   {
    //     path: route.checkboxandRadion,
    //     element: <CheckboxRadios />,
    //     route: Route,
    //   },
    //   {
    //     path: route.inputGroup,
    //     element: <InputGroup />,
    //     route: Route,
    //   },
    //   {
    //     path: route.gridandGutters,
    //     element: <GridGutters />,
    //     route: Route,
    //   },
    //   {
    //     path: route.formSelect,
    //     element: <FormSelect />,
    //     route: Route,
    //   },
    //   {
    //     path: route.formMask,
    //     element: <FormMask />,
    //     route: Route,
    //   },
    //   {
    //     path: route.fileUpload,
    //     element: <FileUpload />,
    //     route: Route,
    //   },
    //   {
    //     path: route.horizontalForm,
    //     element: <FormHorizontal />,
    //     route: Route,
    //   },
    //   {
    //     path: route.verticalForm,
    //     element: <FormVertical />,
    //     route: Route,
    //   },
    //   {
    //     path: route.floatingLable,
    //     element: <FloatingLabel />,
    //     route: Route,
    //   },
    //   {
    //     path: route.formValidation,
    //     element: <FormValidation />,
    //     route: Route,
    //   },
    //   {
    //     path: route.formSelect2,
    //     element: <FormSelect2 />,
    //     route: Route,
    //   },
    //   {
    //     path: route.formWizard,
    //     element: <FormWizard />,
    //     route: Route,
    //   },
    //   {
    //     path: route.formWizard,
    //     element: <DataTables />,
    //     route: Route,
    //   },
    //   {
    //     path: route.dataTable,
    //     element: <DataTables />,
    //     route: Route,
    //   },
    //   {
    //     path: route.tableBasic,
    //     element: <TablesBasic />,
    //     route: Route,
    //   },
    //   {
    //     path: route.iconicIcon,
    //     element: <IonicIcons />,
    //     route: Route,
    //   },
    //   // {
    //   //   path: route.chart,
    //   //   element: <ChartJs />,
    //   //   route: Route,
    //   // },
    //   {
    //     path: route.tasksImportant,
    //     element: <TasksImportant />,
    //     route: Route,
    //   },
    //   {
    //     path: route.tasksCompleted,
    //     element: <TaskCompleted />,
    //     route: Route,
    //   },
  ];
}

export const authRoutes = [
  {
    path: route.comingSoon,
    element: <ComingSoon />,
    route: Route,
  },
  {
    path: route.login,
    element: <Login />,
    route: Route,
  },
  {
    path: route.register,
    element: <Register />,
    route: Route,
  },
  {
    path: route.twoStepVerification,
    element: <TwoStepVerification />,
    route: Route,
  },
  {
    path: route.emailVerification,
    element: <EmailVerification />,
    route: Route,
  },
  {
    path: route.success,
    element: <Success />,
    route: Route,
  },
  {
    path: route.register,
    element: <Register />,
    route: Route,
  },
  {
    path: route.resetPassword,
    element: <ResetPassword />,
    route: Route,
  },
  {
    path: route.forgotPassword,
    element: <ForgotPassword />,
    route: Route,
  },
  {
    path: route.error404,
    element: <Error404 />,
    route: Route,
  },
  {
    path: route.error500,
    element: <Error500 />,
    route: Route,
  },
  {
    path: route.underMaintenance,
    element: <UnderMaintenance />,
    route: Route,
  },
  {
    path: route.lockScreen,
    element: <LockScreen />,
  },
  {
    path: route.blankPage,
    element: <BlankPage />,
  },

];
